import React from 'react';

import {
  FilterProvider,
  SelectedFavouriteStationProvider,
  SelectedFavouriteBrandProvider
} from '../context';

export const withFavouriteStationsModalContext = (Component: any) => ({ ...props }: {}) => (
  <FilterProvider>
    <SelectedFavouriteStationProvider>
      <SelectedFavouriteBrandProvider>
        <Component {...props} />
      </SelectedFavouriteBrandProvider>
    </SelectedFavouriteStationProvider>
  </FilterProvider>
);
